import useContract from './useContract';
import StakingPool from '../contracts/HookableStakingPool.json';

const useNoundleStakingPool = () =>
  useContract(
    process.env.NEXT_PUBLIC_NOUNDLE_STAKING_POOL_CONTRACT_ADDRESS,
    StakingPool.abi
  );

export default useNoundleStakingPool;
